import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';

// --- BİLEŞENLER ---
import Navbar from './components/Navbar';
import FloatingButtons from './components/FloatingButtons';
import Footer from './components/Footer';
import ScrollToTop from "./components/ScrollToTop";

// --- ANA SAYFALAR ---
import Home from './pages/Home';
import Hakkimizda from './pages/Hakkimizda';
import MarkaDetay from './pages/MarkaDetay';
import Iletisim from './pages/Iletisim';
import Blog from './pages/Blog';
import BlogDetay from './pages/BlogDetay';


import BuzdolabiServisi from './pages/servisler/BuzdolabiServisi';
import KombiServisi from './pages/servisler/KombiServisi';
import CamasirMakinesiServisi from './pages/servisler/CamasirMakinesi';
import KlimaServisi from './pages/servisler/KlimaServisi';
import BulasikMakinesi from './pages/servisler/BulasikMakinesi';



function App() {
  return (
    <HelmetProvider>
      <Router>
            <ScrollToTop />

        <div className="app-container">
          {/* Üst Menü */}
          <Navbar />

          <Routes>
            {/* Ana Sayfalar */}
            <Route path="/" element={<Home />} />
            <Route path="/hakkimizda" element={<Hakkimizda />} />
            <Route path="/iletisim" element={<Iletisim />} />
            <Route path="/marka/:markaSlug" element={<MarkaDetay />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetay />} />

            <Route path="/hizmet/buzdolabi-servisi" element={<BuzdolabiServisi />} />
            <Route path="/hizmet/kombi-servisi" element={<KombiServisi />} />
            <Route path="/hizmet/camasir-makinesi-servisi" element={<CamasirMakinesiServisi />} />
            <Route path="/hizmet/klima-servisi" element={<KlimaServisi />} />
            <Route path="/hizmet/bulasik-makinesi-servisi" element={<BulasikMakinesi />} />
          </Routes>

          {/* Yüzen Butonlar (Global: Her sayfada sağ altta) */}
          <FloatingButtons />
        </div>
        
        {/* Alt Menü */}
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;